import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import filterImg from "../../../assets/images/filter.png";
import { SearchInput } from "../../../components";
import AntdTab from "../../../components/AntdTab/AntdTab";
import { AssetsMiddleware } from "../../../Store/Middlewares/AssetsMiddleware";
import styles from "./assets.module.css";
import GroupAssets from "./GroupAssets/GroupAssets";
import SingleAssets from "./SingleAssets/SingleAssets";
import Unlink from "./Unlink/Unlink";
import Pending from "./Pending/Pending";

const Assets = () => {
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();
  const [childSearchFn, setChildSearchFn] = useState(null);
  const [ActiveTab, setActiveTab] = useState("1");
  const [groupAssetDetail, setGroupAssetDetail] = useState(null);

  const ref = useRef();
  const user = useSelector((state) => state.AuthReducer.user);
  const onSearch = (e) => {
    setSearch(e.target.value);
    const value = e.target.value;
    // if (ActiveTab == "1") {
    //   clearTimeout(ref.current);
    //   ref.current = setTimeout(() => {
    //     dispatch(AssetsMiddleware.getvautoAssets("", value)).then((data) => {});
    //   }, 1000);
    // }
    if (ActiveTab == 2) {
      clearTimeout(ref.current);
      ref.current = setTimeout(() => {
        dispatch(AssetsMiddleware.getSingleAssets({ name: value })).then(
          (data) => {},
        );
      }, 1000);
    }
    if (ActiveTab == 1) {
      clearTimeout(ref.current);
      ref.current = setTimeout(() => {
        dispatch(AssetsMiddleware.getUnlinkAssets({ name: value })).then(
          (data) => {},
        );
      }, 1000);
    }
    if (ActiveTab == 4) {
      clearTimeout(ref.current);
      ref.current = setTimeout(() => {
        dispatch(AssetsMiddleware.getPendingAssets({ name: value })).then(
          (data) => {},
        );
      }, 1000);
    }
  };
  const is_immobilized = user?.permissions?.find(
    (x) => x?.name == "action_for_immobilizer",
  );
  const group_immobilizer = user?.permissions?.find(
    (x) => x?.name == "group_immobilizer",
  );
  const add_asset = user?.permissions?.find((x) => x?.name == "add_asset");

  const pair_unpair_device = user?.permissions?.find(
    (x) => x?.name == "pair_unpair_device",
  );

  const items = [
    // {
    //   key: "1",
    //   label: "Dealers Inventory",
    //   children: <Dealer_inventory />,
    // },
    {
      key: "1",
      label: "Unprotected Vehicles",
      children: (
        <Unlink
          is_immobilized={is_immobilized}
          add_asset={add_asset}
          user={user}
          setActiveTab={setActiveTab}
          pair_unpair_device={pair_unpair_device}
        />
      ),
    },
    {
      key: "4",
      label: "Deleted vehicles",
      children: (
        <Pending
          is_immobilized={is_immobilized}
          group_immobilizer={group_immobilizer}
          add_asset={add_asset}
          user={user}
          setGroupAssetDetail={setGroupAssetDetail}
          groupAssetDetail={groupAssetDetail}
          isPending
        />
      ),
    },
    {
      key: "2",
      label: "Protected vehicles",
      children: (
        <SingleAssets
          is_immobilized={is_immobilized}
          add_asset={add_asset}
          user={user}
          setActiveTab={setActiveTab}
          pair_unpair_device={pair_unpair_device}
        />
      ),
    },
    {
      key: "3",
      label: "Group vehicles",
      children: (
        <GroupAssets
          is_immobilized={is_immobilized}
          group_immobilizer={group_immobilizer}
          add_asset={add_asset}
          user={user}
          setGroupAssetDetail={setGroupAssetDetail}
          groupAssetDetail={groupAssetDetail}
        />
      ),
    },
  ];

  useEffect(() => {
    if (ActiveTab == "2") {
      dispatch(AssetsMiddleware.getSingleAssets());
    } else if (ActiveTab == "1") {
      dispatch(AssetsMiddleware.getUnlinkAssets());
    } else if (ActiveTab == "3") {
      dispatch(AssetsMiddleware.getAssetGroup()).then(() => {
        setGroupAssetDetail(null);
      });
    } else if (ActiveTab == "4") {
      dispatch(AssetsMiddleware.getPendingAssets());
    }
  }, [ActiveTab]);

  return (
    <div className={styles.upperCont}>
      <div className={styles.mainCont}>
        <AntdTab
          ActiveTab={ActiveTab}
          setActiveTab={setActiveTab}
          items={items}
          rightItems={
            ActiveTab == 3 ? null : (
              <SearchInput
                onChange={(e) => onSearch(e)}
                // rightIcon={<img src={filterImg} className={styles.filterIcon} />}
                placeholder="Search by last 3 VIN digits, make/model, stock number."
              />
            )
          }
        />
      </div>
    </div>
  );
};

export default Assets;
